<template>
  <div class="ring-profile-container">
    <div class="gem-container">
      <font-awesome-icon v-bind:icon="gemIcon"></font-awesome-icon>
    </div>
    <div v-bind:class="['ring-profile', shape]">
      <div class="vertical-caption">h</div>
    </div>
    <div class="caption">
      <div class="caption-line"></div>
      <div class="caption-text"><span>w</span></div>
    </div>
  </div>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faGem } from '@fortawesome/free-solid-svg-icons'

export default {
  name: 'RingsCalculatorOutputProfile',
  props: {
    shape: { type: String, default: 'semicircular' }
  },
  components: { FontAwesomeIcon },
  data () {
    return {
      gemIcon: faGem
    }
  }
}
</script>

<style scoped lang="scss">
  $container-size: 120px;
  $gem-size: 20px;

  .ring-profile-container {
    width: $container-size;

    & > .gem-container {
      width: $container-size;
      height: $gem-size;
      text-align: center;
      font-size: $gem-size;
      color: $default-link-color;
    }

    & > .ring-profile {
      height: 40px;
      width: 120px;
      // http://www.patternify.com/
      background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAYAAACNMs+9AAAAAXNSR0IArs4c6QAAAD5JREFUKFONzNkJACAMBFHT5Ba5TSoRFI9c8/0YaYVIdsmcIgASwoV05sITufBFJrTQBz10wQhtmKEJK0jhAHdlJwj7JYiDAAAAAElFTkSuQmCC) repeat;
      box-sizing: border-box;
      border: 3px solid $default-heading-color;

      &.semicircular {
        border-radius: 60% / 100%;
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;
      }
      &.rectangular {
        border-radius: 10px;
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;
      }

      & > .vertical-caption {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100%;
        width: 1em;
        position: relative;
        left: 50%;
        border-left: 1px solid $default-heading-color;
        color: $default-heading-color;
      }
    }

    & > .caption {
      font-family: "Gotham Pro Regular", $font-stack;
      color: $default-heading-color;
      height: $gem-size;
      width: 100%;

      border-left: 1px solid $default-text-color;
      border-right: 1px solid $default-text-color;
      box-sizing: border-box;

      display: flex;
      justify-content: center;
      align-items: center;

      position: relative;
      z-index: 2;

      & > .caption-line {
        position: absolute;
        width: 100%;
        z-index: 1;
        border-top: 1px solid $default-text-color;
        top: 50%;
      }
      & > .caption-text {
        position: relative;
        z-index: 2;
        & > span {
          background-color: $content-background-color;
          padding: 0 0.5em;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/the-content/RingsCalculatorOutputProfile.vue